import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import { providerColor } from '../utils/providerColors';

export default class ResourcePanel extends Component {
  resource: any = null;
  images: any[] = [];
  links: any[] = [];
  title = '';
  loading = true;
  lightboxIndex = -1;
  keyHandler: ((e: KeyboardEvent) => void) | null = null;

  oninit(vnode: any) {
    super.oninit(vnode);
    this.load();
  }

  async load() {
    const resourceId = this.attrs.resourceId;
    let url;
    if (resourceId) {
      url = app.forum.attribute('apiUrl') + '/resources/' + resourceId + '?include=discussion,links,images';
    } else {
      const discussionId = this.attrs.discussion.id();
      url = app.forum.attribute('apiUrl') + '/resources?filter[discussion]=' + discussionId + '&include=discussion,links,images';
    }
    try {
      const result = await app.request({ method: 'GET', url });
      this.resource = resourceId ? result.data : result.data?.[0] || null;
      if (this.resource) {
        const inc = result.included || [];
        this.images = inc.filter((x: any) => x.type === 'resource-images');
        this.links = inc.filter((x: any) => x.type === 'resource-links');
        this.title = inc.find((x: any) => x.type === 'discussions')?.attributes?.title || this.attrs.discussion?.title?.() || '';
      }
    } catch (e) {
      this.resource = null;
    }
    this.loading = false;
    m.redraw();
  }

  view() {
    if (this.loading || !this.resource) return null;

    const attrs = this.resource.attributes;
    const rh = app.forum.attribute('resourceHub') || {};
    const cover = this.images.find((i: any) => i.attributes.type === 'cover') || this.images[0];
    const gallery = this.images.filter((i: any) => i.attributes.type !== 'cover');

    return (
      <div className="ResourcePanel">
        <div className="ResourcePanel-main">
          {cover && (
            <div className="ResourcePanel-cover">
              <img
                src={cover.attributes.url || cover.attributes.thumbnailUrl}
                width={cover.attributes.width}
                height={cover.attributes.height}
                loading="lazy"
                onclick={() => this.openLightbox(this.images.indexOf(cover))}
              />
            </div>
          )}

          <div className="ResourcePanel-meta">
            <h2 className="ResourcePanel-title">{this.title}</h2>
            <dl>
              <dt>分类</dt>
              <dd>{this.categoryLabel(rh, attrs.category)}</dd>
              <dt>类型</dt>
              <dd>{this.typeLabel(rh, attrs.category, attrs.resourceType)}</dd>
              {(attrs.software || []).length > 0 && (
                <>
                  <dt>软件</dt>
                  <dd>{(attrs.software || []).map((s: string) => this.labelFor(rh.software, s)).join(' / ')}</dd>
                </>
              )}
              {(attrs.formats || []).length > 0 && (
                <>
                  <dt>格式</dt>
                  <dd>{(attrs.formats || []).map((f: string) => f.toUpperCase()).join(' / ')}</dd>
                </>
              )}
              {attrs.currentVersion && (
                <>
                  <dt>版本</dt>
                  <dd>{attrs.currentVersion}</dd>
                </>
              )}
              {attrs.licenseType && (
                <>
                  <dt>授权</dt>
                  <dd>{attrs.licenseType}</dd>
                </>
              )}
              <dt>来源</dt>
              <dd>{this.labelFor(rh.sourceTypes, attrs.sourceType)}</dd>
              <dt>语言</dt>
              <dd>{attrs.language || '—'}</dd>
              <dt>价格</dt>
              <dd>{attrs.isFree ? '免费' : '付费'}</dd>
            </dl>
          </div>
        </div>

        {this.links.length > 0 && (
          <div className="ResourcePanel-downloads">
            <div className="ResourcePanel-sectionTitle">下载 / 链接</div>
            <div className="ResourcePanel-links">
              {this.links.map((link: any) => (
                <div className="ResourceLink">
                  <span className="ResourceLink-provider" style={'background:' + providerColor(link.attributes.provider)}>
                    {this.labelFor(rh.providers, link.attributes.provider)}
                  </span>
                  <span className="ResourceLink-type">{this.labelFor(rh.linkTypes, link.attributes.linkType)}</span>
                  <span className="ResourceLink-url" title={link.attributes.url}>
                    {link.attributes.url}
                  </span>
                  <a className="Button Button--primary ResourceLink-open" href={link.attributes.url} target="_blank" rel="noopener noreferrer">
                    打开
                  </a>
                  {link.attributes.extractCode && <span className="ResourceLink-code">提取码：{link.attributes.extractCode}</span>}
                  {link.attributes.password && <span className="ResourceLink-code">密码：{link.attributes.password}</span>}
                </div>
              ))}
            </div>
          </div>
        )}

        {gallery.length > 0 && (
          <div className="ResourcePanel-gallery">
            <div className="ResourcePanel-sectionTitle">预览图</div>
            <div className="ResourcePanel-galleryGrid">
              {gallery.map((img: any) => (
                <img
                  className="ResourcePanel-galleryItem"
                  src={img.attributes.thumbnailUrl}
                  width={img.attributes.width}
                  height={img.attributes.height}
                  loading="lazy"
                  onclick={() => this.openLightbox(this.images.indexOf(img))}
                />
              ))}
            </div>
          </div>
        )}

        {this.lightboxIndex >= 0 && this.renderLightbox()}
      </div>
    );
  }

  renderLightbox() {
    const img = this.images[this.lightboxIndex];
    if (!img) return null;
    return (
      <div
        className="ResourceLightbox"
        onclick={() => (this.lightboxIndex = -1)}
        oncreate={() => this.onLightboxCreate()}
        onremove={() => this.onLightboxRemove()}
      >
        <img src={img.attributes.url} onclick={(e: any) => e.stopPropagation()} />
        <Button className="Button Button--icon ResourceLightbox-close" icon="fas fa-times" onclick={() => (this.lightboxIndex = -1)} />
        {this.images.length > 1 && (
          <>
            <Button className="Button Button--icon ResourceLightbox-prev" icon="fas fa-chevron-left" onclick={(e: any) => { e.stopPropagation(); this.lightboxIndex = (this.lightboxIndex - 1 + this.images.length) % this.images.length; }} />
            <Button className="Button Button--icon ResourceLightbox-next" icon="fas fa-chevron-right" onclick={(e: any) => { e.stopPropagation(); this.lightboxIndex = (this.lightboxIndex + 1) % this.images.length; }} />
          </>
        )}
      </div>
    );
  }

  openLightbox(index: number) {
    this.lightboxIndex = index;
    m.redraw();
  }

  onLightboxCreate() {
    this.keyHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        this.lightboxIndex = -1;
      } else if (e.key === 'ArrowLeft') {
        this.lightboxIndex = (this.lightboxIndex - 1 + this.images.length) % this.images.length;
      } else if (e.key === 'ArrowRight') {
        this.lightboxIndex = (this.lightboxIndex + 1) % this.images.length;
      }
      m.redraw();
    };
    document.addEventListener('keydown', this.keyHandler);
  }

  onLightboxRemove() {
    if (this.keyHandler) {
      document.removeEventListener('keydown', this.keyHandler);
      this.keyHandler = null;
    }
  }

  categoryLabel(rh: any, key: string) {
    return rh.categories?.find((c: any) => c.key === key)?.label || key;
  }

  typeLabel(rh: any, category: string, type: string) {
    return rh.categories?.find((c: any) => c.key === category)?.types?.find((t: any) => t.key === type)?.label || type;
  }

  labelFor(registry: any[], key: string) {
    return registry?.find((x: any) => x.key === key)?.label || key;
  }
}
